<template>
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <div class="login100-form-title"  :style="{'background-image': 'url(' + require('../assets/img/bg-01.jpg') + ')'}">
					<span class="login100-form-title-1">
						Hostbool
					</span>
                </div>
                <form class="login100-form validate-form" >
                    <div class="wrap-input100 validate-input m-b-26" data-validate="Username is required">
                        <span class="label-input100">Username</span>
                        <input class="input100" type="text" name="username" placeholder="Enter username" v-model="username" ref="username">
                        <span class="focus-input100"></span>
                    </div>
                    <div class="wrap-input100 validate-input m-b-18" data-validate="Password is required">
                        <span class="label-input100">Password</span>
                        <input class="input100" type="password" name="pass" placeholder="Enter password" v-model="password" ref="password">
                        <span class="focus-input100"></span>
                    </div>
                    <div class="flex-sb-m w-full p-b-25"></div>
                    <div class="container-login100-form-btn">
                        <button class="login100-form-btn" @click.prevent="submit">
                            Login
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data : function () {
            return {
                password : '',
                username : ''
            }
        },
        methods : {
            submit() {
                if(!this.username)
                {
                    alert('Enter Username');
                    this.$refs.username.focus();
                }
                else if(!this.password)
                {
                    alert('Enter Password');
                    this.$refs.password.focus();
                }
                else
                {
                    setTimeout(() => {  alert('You have entered an invalid username or password'); }, 500);
                    this.$refs.username.focus();
                }
            }
        }
    }
</script>
